import { faMinusCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Container, Tabs, Tab, Row, Col, Spinner } from "react-bootstrap";
import usePortfolioInformation from "./usePortfolioInformation";
import useCandidateProfile from "../../CandidateProfile/useCandidateProfile";

export default (props) => {
  const {
    onInputBlur,
    allPortfolio,
    updatePorfolio,
    deletePorfolioLink,
    SetAddNewPortfolio,
    addNewPortfolio,
    loading,
    onAddPortfolioCancleClick,
  } = usePortfolioInformation(props);

  return (
    <div className="hiring-process-dashboard  hiring-manager-profile-wrapper">
      <div className="job-detail-wrapper mt-4 pr-lg-4">
            <div className="job-detail col-md-8 bg-white border border-radius-10 p-4">
                <h2 className="mb-3">My portfolio</h2>
              <div className="py-3 form-group mb-0">
                <Row>
                  <Col lg={10}>
                    <p className="font-weight-medium">
                      <span className="text-danger">* </span>Portfolio URL
                    </p>
                    {loading ? (
                      <>
                        <div className="d-flex justify-content-center align-items-center w-100">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      </>
                    ) : (
                      <>
                        {allPortfolio &&
                          Array.isArray(allPortfolio) &&
                          allPortfolio.map((item) => (
                            <div className="form-group d-flex align-items-center">
                              <input
                                className="form-control mw-100"
                                type="text"
                                name={"portfolio_url"}
                                onBlur={(e) => updatePorfolio(e, item?.id)}
                                placeholder="eg: https://www.myportfolio.com/"
                                defaultValue={item?.portfolio_url}
                              />
                              <button
                                className="border-0 bg-transparent text-danger ml-3 text-nowrap"
                                onClick={() => deletePorfolioLink(item?.id)}
                              >
                                <FontAwesomeIcon
                                  icon={faMinusCircle}
                                  className="mr-2"
                                />
                                Delete
                              </button>
                            </div>
                          ))}
                      </>
                    )}
                    {addNewPortfolio ? (
                      <div className="form-group d-flex align-items-center mb-0">
                        <input
                          className="form-control mw-100"
                          type="text"
                          name={"portfolio_url"}
                          onBlur={onInputBlur}
                          placeholder="eg: https://www.myportfolio.com/"
                        />
                        <button
                          className="btn btn-primary ml-3"
                          onClick={onAddPortfolioCancleClick}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : null}
                  </Col>

                  {!addNewPortfolio ? (
                      <button
                        className="btn text-primary font-weight-medium"
                        onClick={() => {
                          SetAddNewPortfolio(true);
                        }}
                      >
                        + Add New Portfolio Link
                      </button>
                  ) : null}
                </Row>
              </div>
            </div>
      </div>
    </div>
  );
};
